import {
  Container,
  TypographyElement,
  Icon,
  Icons,
  MediaQuery,
  Slider
} from 'UI'
import classNames from 'classnames'
import { useRef, useEffect, useState } from 'react'
import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import Text from './text.json'
import { chunk } from 'lodash'
import SocialMedia from 'components/common/SocialMedia'
import { TwitterShareLink, LinkdinShareLink, FacebookShareLink } from 'constants/'
import DesktopGalleryView from '../DesktopGalleryView'
import ResponsiveGalleryView from '../ResponsiveGalleryView'

const useStyles = createUseStyles(style)
const imagesToShow = 6
const previousImageOffset = 2
const nextImageOffset = 4

const viewsDesktop = (
  view,
  learningPathProjects,
  setSelectedProject,
  setSelectedImage,
  setShowPopUp,
  selectedProject,
  selectedProjectStyle,
  cardStyle,
  image
) => {
  const splicedProjectDetails = chunk(learningPathProjects, 6)
  const additionalAlt = selectedProject?.Tags.join(', ')
  return splicedProjectDetails.map((item, index) => (
    <div key={index} className={view}>
      {item.map((project, key) => (
        <div key={key} className={cardStyle}>
          <img
            key={project.CourseId}
            src={project.ProjectImages[0].SmallImageLink}
            alt={`${project.ProjectImages[0].Text} ${additionalAlt}`}
            height={86}
            width={153}
            className={classNames(
              image,
              project.CourseId === selectedProject.CourseId
                ? selectedProjectStyle
                : ''
            )}
            onClick={() => {
              setSelectedProject(project)
              setSelectedImage(project.ProjectImages[0])
              setShowPopUp(true)
            }}
          />
          <TypographyElement
            variant='caption'
          >
            {Text.project} {(index * 6) + key + 1}
          </TypographyElement>
        </div>
      ))}
    </div>
  ))
}

export default ({
  scrollToPricing,
  showPopUp,
  setShowPopUp,
  showPricing,
  projectDetails,
  selectedImage,
  setSelectedImage,
  selectedProject,
  setSelectedProject,
  isLearningPath,
  learningPathProjects,
  isMobile,
  courseTitle,
  tags
}) => {
  const theme = useTheme()
  const {
    overlay,
    wrapper,
    closeIcon,
    image,
    view,
    cardStyle,
    sliderHeader,
    container,
    selectedProjectStyle,
    socialMediaContainer
  } = useStyles({ isMobile })
  const imagesArray = isLearningPath ? selectedProject?.ProjectImages : projectDetails
  const [projectArray, setProjectArray] = useState(null)
  const node = useRef()
  const handleClose = () => {
    setShowPopUp(false)
    setProjectArray(imagesArray?.slice(0, imagesToShow))
  }
  const handleNewSelectedImage = (currentIndex, offset) => {
    const newIndex = (currentIndex + offset + imagesArray.length) % imagesArray.length
    return imagesArray[newIndex]
  }

  const handleImageClick = (image) => {
    const currentIndex = imagesArray.findIndex((project) => project.ImageId === image.ImageId)
    setSelectedImage(image)
    if (currentIndex === imagesArray.length) {
      setProjectArray(imagesArray.slice(0, imagesToShow))
    } else if (currentIndex >= imagesToShow - previousImageOffset) {
      setProjectArray(imagesArray.slice(currentIndex - previousImageOffset, currentIndex + nextImageOffset))
    } else if (currentIndex <= imagesToShow) {
      setProjectArray(imagesArray.slice(0, imagesToShow))
    }
  }

  const handlePreviousImage = () => {
    const currentIndex = imagesArray.findIndex((project) => project.ImageId === selectedImage?.ImageId)
    setSelectedImage(handleNewSelectedImage(currentIndex, -1))
    if (currentIndex === 0 && imagesArray.length > imagesToShow) {
      setProjectArray(imagesArray.slice(imagesArray.length - (imagesToShow - 1), imagesArray.length))
    } else if (currentIndex <= imagesToShow) {
      setProjectArray(imagesArray.slice(0, imagesToShow))
    } else if (currentIndex === 0) {
      setProjectArray(imagesArray.slice(0, imagesToShow))
    }
  }

  const handleNextImage = () => {
    const currentIndex = imagesArray.findIndex((project) => project.ImageId === selectedImage?.ImageId)
    setSelectedImage(handleNewSelectedImage(currentIndex, 1))
    if (currentIndex >= imagesToShow - 2) {
      setProjectArray(imagesArray.slice(currentIndex - previousImageOffset, currentIndex + nextImageOffset))
      if (currentIndex === imagesArray.length - 1) {
        setProjectArray(imagesArray.slice(0, imagesToShow))
      }
    }
  }

  useEffect(() => {
    if (imagesArray) {
      setSelectedImage(imagesArray[0])
      setProjectArray(imagesArray?.slice(0, imagesToShow))
    }
  }, [imagesArray])
  if (!showPopUp) return null

  const overlayTitle = isLearningPath
    ? learningPathProjects?.find((project) => project.CourseId === selectedProject?.CourseId)?.Title
    : isMobile ? selectedImage?.Text : courseTitle
  return (
    <div className={overlay}>
      <div className={wrapper} ref={node}>
        <Container className={container}>
          <div className={closeIcon}>
            <TypographyElement
              variant='body1'
            >
              {overlayTitle}
            </TypographyElement>
            <Icon iconName={Icons.close} onHandleIconClick={handleClose} />
          </div>
          <MediaQuery ShowOnDesktop>
            <DesktopGalleryView
              scrollToPricing={scrollToPricing}
              projectArray={projectArray}
              setProjectArray={setProjectArray}
              showPopUp={showPopUp}
              setShowPopUp={setShowPopUp}
              showPricing={showPricing}
              projectDetails={projectDetails}
              selectedImage={selectedImage}
              setSelectedImage={setSelectedImage}
              selectedProject={selectedProject}
              isLearningPath={isLearningPath}
              learningPathProjects={learningPathProjects}
              handlePreviousImage={handlePreviousImage}
              handleNextImage={handleNextImage}
              handleImageClick={handleImageClick}
              imagesArray={imagesArray}
              tags={selectedProject?.Tags ?? tags}
            />
          </MediaQuery>
          <MediaQuery HideOnDesktop>
            <ResponsiveGalleryView
              showPopUp={showPopUp}
              setShowPopUp={setShowPopUp}
              projectDetails={projectDetails}
              selectedImage={selectedImage}
              setSelectedImage={setSelectedImage}
              selectedProject={selectedProject}
              setSelectedProject={setSelectedProject}
              isLearningPath={isLearningPath}
              learningPathProjects={learningPathProjects}
              isMobile={isMobile}
              handlePreviousImage={handlePreviousImage}
              handleNextImage={handleNextImage}
              handleImageClick={handleImageClick}
              imagesArray={imagesArray}
              tags={selectedProject?.Tags ?? tags}
            />
          </MediaQuery>
          <MediaQuery ShowOnDesktop>
            {isLearningPath && (
              <Slider
                title={Text.learningPathProject}
                gap={16}
                views={
                viewsDesktop(
                  view,
                  learningPathProjects,
                  setSelectedProject,
                  setSelectedImage,
                  setShowPopUp,
                  selectedProject,
                  selectedProjectStyle,
                  cardStyle,
                  image
                )
              }
                titleProps={{
                  fontSize: '16px',
                  backgroundColor: theme.neutral[400]
                }}
                headerStyle={sliderHeader}
              />
            )}
            <div className={socialMediaContainer}>
              <SocialMedia
                title={Text.shareOnSocialMedia}
                shareLinks={{
                  facebookShareLink: FacebookShareLink,
                  twitterShareLink: TwitterShareLink,
                  linkedinShareLink: LinkdinShareLink
                }}
              />
            </div>
          </MediaQuery>
        </Container>
      </div>
    </div>
  )
}
